import {
  API, GET, POST, PATCH, DELETE,
} from '../middleware/api';
import { API_URL } from '../config';

// Ajoneuvo-/laitetyypit of one organization; same contract as toimipisteet
// (businessUnitActions.js).

export function fetchAssetCategories(organizationId) {
  return {
    [API]: {
      method: GET,
      url: `${API_URL}/uiapi/1/asset_category/`,
      types: [
        'FETCH_ASSET_CATEGORIES_REQUEST',
        'FETCH_ASSET_CATEGORIES_SUCCESS',
        'FETCH_ASSET_CATEGORIES_FAIL',
      ],
      params: { organization_id: organizationId },
    },
  };
}

export function createAssetCategory(data) {
  return {
    [API]: {
      method: POST,
      url: `${API_URL}/uiapi/1/asset_category/`,
      types: [
        'CREATE_ASSET_CATEGORY_REQUEST',
        'CREATE_ASSET_CATEGORY_SUCCESS',
        'CREATE_ASSET_CATEGORY_FAIL',
      ],
      data,
      params: { organization_id: data.organization },
    },
  };
}

export function updateAssetCategory(assetCategoryId, data, organizationId) {
  return {
    [API]: {
      method: PATCH,
      url: `${API_URL}/uiapi/1/asset_category/${assetCategoryId}/`,
      types: [
        'UPDATE_ASSET_CATEGORY_REQUEST',
        'UPDATE_ASSET_CATEGORY_SUCCESS',
        'UPDATE_ASSET_CATEGORY_FAIL',
      ],
      data,
      params: { organization_id: organizationId },
    },
  };
}

export function deleteAssetCategory(assetCategoryId, organizationId) {
  return {
    [API]: {
      method: DELETE,
      url: `${API_URL}/uiapi/1/asset_category/${assetCategoryId}/`,
      types: [
        'DELETE_ASSET_CATEGORY_REQUEST',
        'DELETE_ASSET_CATEGORY_SUCCESS',
        'DELETE_ASSET_CATEGORY_FAIL',
      ],
      additionalData: {
        itemId: assetCategoryId,
      },
      params: { organization_id: organizationId },
    },
  };
}
